// Main JavaScript file for Sev2 website

document.addEventListener('DOMContentLoaded', () => {
  // Handle form submission
  const contactForm = document.getElementById('contact-form');
  
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      
      // Get form data
      const name = document.getElementById('name').value;
      const company = document.getElementById('company').value;
      const email = document.getElementById('email').value;
      const message = document.getElementById('message').value;
      
      // Show loading state
      const submitButton = contactForm.querySelector('button[type="submit"]');
      const originalButtonText = submitButton.textContent;
      submitButton.textContent = 'Sending...';
      submitButton.disabled = true;
      
      // Simulate server processing with a short delay
      setTimeout(() => {
        // Log the form data to console (for development purposes)
        console.log('Form submission:', { name, company, email, message });
        
        // Reset button state
        submitButton.textContent = originalButtonText;
        submitButton.disabled = false;
        
        // Show success message
        const formContainer = contactForm.parentElement;
        contactForm.style.display = 'none';
        
        const successMessage = document.createElement('div');
        successMessage.className = 'success-message';
        successMessage.innerHTML = `
          <h3>Thank you for your inquiry!</h3>
          <p>We appreciate your interest in Sev2. A member of our team will review your project details and get back to you within 1-2 business days.</p>
          <p class="inquiry-details">
            <strong>Inquiry Reference:</strong> SEV2-${generateReferenceNumber()}<br>
            <strong>Submitted:</strong> ${formatDate(new Date())}
          </p>
          <button class="btn" id="new-inquiry">Submit Another Inquiry</button>
        `;
        
        formContainer.appendChild(successMessage);
        
        // Add event listener to the "Submit Another Inquiry" button
        document.getElementById('new-inquiry').addEventListener('click', () => {
          successMessage.remove();
          contactForm.reset();
          contactForm.style.display = 'block';
        });
      }, 1500); // 1.5 second delay to simulate server processing
    });
  }
  
  // Generate a random reference number for inquiries
  function generateReferenceNumber() {
    const timestamp = new Date().getTime().toString().slice(-6);
    const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    return `${timestamp}-${random}`;
  }
  
  // Format date in a readable format
  function formatDate(date) {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return date.toLocaleDateString('en-US', options);
  }
  
  // Smooth scrolling for navigation links
  const navLinks = document.querySelectorAll('nav a, .footer-links a');
  
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href');
      
      // Only apply smooth scrolling to hash links
      if (targetId.startsWith('#')) {
        e.preventDefault();
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          const headerHeight = document.querySelector('header').offsetHeight;
          window.scrollTo({
            top: targetElement.offsetTop - headerHeight,
            behavior: 'smooth'
          });
        }
      }
    });
  });
  
  // Add static futuristic elements to hero section
  const createFuturisticElements = () => {
    // Create digital circuit lines
    const hero = document.querySelector('.hero');
    const circuitContainer = document.createElement('div');
    circuitContainer.className = 'circuit-lines';
    
    // Create static circuit paths
    for (let i = 0; i < 5; i++) {
      const circuit = document.createElement('div');
      circuit.className = 'circuit';
      circuit.style.top = `${Math.random() * 100}%`;
      circuit.style.left = `${Math.random() * 100}%`;
      circuit.style.width = `${Math.random() * 200 + 100}px`;
      circuit.style.height = `${Math.random() * 200 + 100}px`;
      circuitContainer.appendChild(circuit);
    }
    
    // Add glowing dots at circuit intersections
    for (let i = 0; i < 15; i++) {
      const dot = document.createElement('div');
      dot.className = 'circuit-dot';
      dot.style.top = `${Math.random() * 100}%`;
      dot.style.left = `${Math.random() * 100}%`;
      circuitContainer.appendChild(dot);
    }
    
    hero.insertBefore(circuitContainer, hero.firstChild);
  };
  
  createFuturisticElements();
});
